// ** React Imports
import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Divider,
  Fab,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Stack,
  TextField,
  Typography,
  Button,
  Checkbox,
} from "@mui/material";
import { Close, ErrorOutline } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  assignRoom,
  getNonBlockedRooms,
  getUpgradePricePayload,
  invalidateNightAuditReservation,
} from "../../CalendarPage/api/ReservationApi";

import { PriceModel } from "../../CalendarPage/models/PricesModel";
import { shallowEqual, useSelector } from "react-redux";
import CommonSlider from "../../CalendarPage/Views/CommonSlider";
import DimmingDotsLoader from "../../CalendarPage/Views/LoaderCustom";
import { getAllNonHiddenRoomTypes } from "../../InventoryCalendar/api/InventoryApi";
import { customErrorMessage } from "../../CalendarPage/constants/Calendar-constants";
import { toast } from "material-react-toastify";
import "material-react-toastify/dist/ReactToastify.css";
import { handleSpringDataRequest } from "../../../api";
import i18n from "../../../modules/Auth/pages/i18n";
import { useTranslation } from "react-i18next"; // Import useTranslation hook

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    padding: theme.spacing(2),
  },
  footer: {
    margin: theme.spacing(3),
    float: "right",
  },
}));

const ReassignRoomFolio = (props) => {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(props.selectedLanguage);
  }, [props.selectedLanguage]);
  const { hotel } = useSelector(
    ({ auth }) => ({
      hotel: auth.selectedHotel,
    }),
    shallowEqual
  );

  const validationSchema = yup.object({
    perNightPrice: yup.number().required(`${t("Please enter a valid amount")}`),
    priceBeforeTax: yup
      .number()
      .required(`${t("Please enter a valid amount")}`),
    priceAfterTax: yup.number().required(`${t("Please enter a valid amount")}`),
    taxValue: yup.number().required(`${t("Please enter a valid amount")}`),
    numNights: yup.number().nullable(),
    roomId: yup.string().required(`${t("Please select a valid room id")}`),
  });

  const hotelId = hotel.hotelId;
  const currency = hotel?.accessControl?.hotel?.hotel_currency;
  const { eventData, handleAddEventSidebar, open, refetch, getData } = props;
  let [pricingRequestModel, setPricingRequestModel] = useState(
    new PriceModel({})
  );
  let [loadingData, setLoadingData] = useState(false);
  let [load, setLoad] = useState(false);
  const [showError, setShowError] = useState(false);
  const [roomTypes, setRoomTypes] = useState({});
  const [selectedRoomType, setSelectedRoomType] = useState(
    eventData.roomTypeId
  );
  const [roomIds, setRoomIds] = useState([]);
  const [showButtonOfPricing, setshowButtonOfPricing] = useState("");
  const [selectedRatePlan, setselectedRatePlan] = useState("");
  const [allRatePlans, setallRatePlans] = useState([]);
  const [ratePlanObj, setratePlanObj] = useState({});
  const [ratePlanchecked, setRatePlanChecked] = useState(false);

  const handleRatePlanChange = (event) => {
    setRatePlanChecked(event.target.checked);
  };

  const performCheckin = async (params) => {
    setLoad(true);
    try {
      await assignRoom(params).then(() => {
        toast.success(
          `${t("Successfully assigned room  for")} ${eventData.bookingId}`
        );
      });

      if (Number(params.moveCost) !== 0) {
        await invalidateNightAuditReservation(params.reservationId);
      }

      refetch();
      getData();
    } catch (e) {
      const message = e.message ? e.message : customErrorMessage;
      toast.error(
        typeof message === "string" || message instanceof String
          ? message
          : customErrorMessage
      );
      console.log(e);
      getData();
      handleAddEventSidebar();
    }
  };

  const fetchUpdatedBookingPricing = async (val, rateplan) => {
    try {
      setLoad(true);
      pricingRequestModel.destRoomTypeId = selectedRoomType;
      if (val === "new") {
        pricingRequestModel["destRatePlanId"] = ratePlanchecked
          ? rateplan
          : null;
      } else {
        pricingRequestModel["destRatePlanId"] = ratePlanchecked
          ? selectedRatePlan
          : null;
      }

      if (pricingRequestModel.hotelId === "") {
        pricingRequestModel["hotelId"] = hotelId;
      }

      const resp = await getUpgradePricePayload(
        pricingRequestModel.getUpgradeBookingparams()
      );

      setData(resp);
      setshowButtonOfPricing("");
      setLoad(false);
    } catch (e) {
      console.log(e);
    }
  };
  const setData = (resp) => {
    formik.setFieldValue(
      "perNightPrice",
      Number(resp.perNightPrice).toFixed(2)
    );
    formik.setFieldValue(
      "priceBeforeTax",
      Number(resp.priceBeforeTax).toFixed(2)
    );
    formik.setFieldValue(
      "priceAfterTax",
      Number(resp.priceAfterTax).toFixed(2)
    );
    formik.setFieldValue("taxValue", Number(resp.taxValue).toFixed(2));
  };

  const fetchInitialPricing = async () => {
    const pricesModel = new PriceModel({
      hotelId: hotelId,
      resIds: eventData.reservationId,
      checkin: eventData.checkin,
      checkout: eventData.actualCheckout,
      newRate: null,
      bookingId: eventData.bookingId,
    });
    setPricingRequestModel(pricesModel);

    pricesModel.destRoomTypeId = eventData.roomTypeId;
    const [rooms, resp, ids] = await Promise.all([
      getAllNonHiddenRoomTypes(),
      getUpgradePricePayload(pricesModel.getUpgradeBookingparams()),
      // getNonBlockedRooms(eventData.roomType, eventData.id),
    ]);
    setData(resp);
    setRoomTypes(rooms);
    setSelectedRoomType(eventData.roomTypeId);
    handleSpringDataRequest(
      `core/api/v1/room/non-blocked-rooms-with-status?roomTypeId=${eventData.roomTypeId}&resId=${eventData.reservationId}`
    )
      .then((res) => {
        setRoomIds(res);
      })
      .catch((err) => console.log(err));

    // const splitIds = String(ids).split(",");
    // setRoomIds(splitIds);
  };

  const fetchCheckinPricing = async () => {
    setLoadingData(true);
    try {
      await fetchInitialPricing();
      setLoadingData(false);
    } catch (e) {
      console.log(e);
      setLoadingData(false);
      setShowError(true);
    }
  };

  const classes = useStyles();

  useEffect(() => {
    fetchCheckinPricing();
  }, []);

  const formik = useFormik({
    enableReinitialize: false,
    initialValues: {
      perNightPrice: 0,
      priceBeforeTax: 0,
      priceAfterTax: 0,
      taxValue: 0,
      roomId: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      var temporary = {};
      temporary = {
        reservationId: eventData.reservationId,
        physicalRoomId: values.roomId,
        hotelId: hotelId,
        destRoomTypeId: selectedRoomType,
        moveCost: values.priceAfterTax,
        destRatePlanId: ratePlanchecked ? selectedRatePlan : null,
        destRatePlan: ratePlanchecked ? ratePlanObj[selectedRatePlan] : null,
      };

      temporary = performCheckin(temporary);
    },
  });

  //   const getCustomDate = () => {
  //     const date1 = new Date(formik.values.booking_start);
  //     const date2 = new Date(formik.values.booking_end);
  //     if (viewType === "resourceTimelineWeek") {
  //       if (checkinSlots.length === 1) {
  //         date1.setHours(displayTimes[1]);
  //         date2.setHours(displayTimes[1]);
  //       } else if (checkinSlots.length === 3) {
  //         const slot1 = checkinSlots.indexOf(selectedCheckinSlot);
  //         const slot2 = checkoutSlots.indexOf(selectedCheckoutSlot);
  //         date1.setHours(displayTimes[slot1]);
  //         date2.setHours(displayTimes[slot2]);
  //       }
  //     }
  //     return { start: date1, end: date2 };
  //   };

  const refetchIds = async (roomId) => {
    formik.setFieldValue("roomId", "");

    handleSpringDataRequest(
      `core/api/v1/room/non-blocked-rooms-with-status?roomTypeId=${roomId}&resId=${eventData.reservationId}`
    )
      .then((res) => {
        setRoomIds(res);
      })
      .catch((err) => console.log(err));
    // const ids = await getNonBlockedRooms(roomId, eventData.id);
    // setRoomIds(String(ids).split(","));
  };

  const getRatePlans = () => {
    handleSpringDataRequest(
      `core/api/v1/reservation/get-room-type-rate-plan?reservationId=${eventData.reservationId}&roomTypeId=${selectedRoomType}`
    ).then((res) => {
      const ratePlanObj = res.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});

      setratePlanObj(ratePlanObj); // Store the transformed object

      if (res.length > 0) {
        setallRatePlans(Object.entries(ratePlanObj)); // Keep original array for UI or dropdown list

        // Select the first rate plan's id as default
        setselectedRatePlan(res[0].id);

        // Call handleGetUpgradeCost with the first rate plan's id
        fetchUpdatedBookingPricing("new", res[0].id);
      }
    });
  };

  useEffect(() => {
    if (
      selectedRoomType !== null &&
      selectedRoomType !== undefined &&
      selectedRoomType !== "" &&
      ratePlanchecked
    ) {
      getRatePlans();
    }
  }, [selectedRoomType, ratePlanchecked]);

  useEffect(() => {
    if (!ratePlanchecked) {
      fetchUpdatedBookingPricing();
    }
  }, [ratePlanchecked]);
  return (
    <div className={classes.root}>
      <CommonSlider open={open} onClose={handleAddEventSidebar}>
        <Grid container sx={{ height: "100%", width: "100%" }}>
          <Grid container height={"max-content"} className={classes.textField}>
            <Grid item xs={10} alignSelf="center">
              <Typography variant="h5">{t("Assign Room")}</Typography>
            </Grid>
            <Grid item xs={2}>
              <IconButton
                sx={{ float: "right" }}
                onClick={handleAddEventSidebar}
              >
                <Close />
              </IconButton>
            </Grid>
          </Grid>
          {loadingData && (
            <Grid
              sx={{ width: "100%", height: "max-content" }}
              container
              alignItems="center"
              direction="column"
              justifyContent="center"
            >
              <DimmingDotsLoader />
            </Grid>
          )}
          {!showError && !loadingData && (
            <form
              noValidate
              style={{ height: "inherit" }}
              onSubmit={formik.handleSubmit}
            >
              <Grid container className={classes.textField} spacing={1}>
                <Grid item xs={12}>
                  <Typography>
                    {`${t("Booking ID")}: ${eventData.bookingId}`}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography>{`${t("Customer Name")}: ${
                    eventData.name
                  }`}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography>{`${t("Checkin")}: ${
                    eventData.checkin
                  }`}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography>{`${t("Checkout")}: ${
                    eventData.checkout
                  }`}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <div
                    className="d-flex"
                    style={{
                      alignItems: "center",
                      marginBottom: "1rem",
                      marginLeft: "-0.9rem",
                    }}
                  >
                    <Checkbox
                      checked={ratePlanchecked}
                      onChange={handleRatePlanChange}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <p
                      style={{
                        marginLeft: "0.5rem",
                        marginBottom: "0px",
                      }}
                    >
                      Edit rate plan
                    </p>
                  </div>
                </Grid>
                {/* <Grid item xs={12}>
                  <Typography>{`Roomtype: ${eventData.type}`}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography>
                    {`Rate plan: ${eventData.ratePlanName}`}
                  </Typography>
                </Grid> */}
              </Grid>

              <Grid container className={classes.textField} spacing={2}>
                <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                  <TextField
                    label={t("Room types")}
                    fullWidth
                    value={selectedRoomType}
                    onChange={(e) => {
                      setSelectedRoomType(e.target.value);
                      refetchIds(e.target.value);
                    }}
                    select
                  >
                    {Object.keys(roomTypes).map((id) => (
                      <MenuItem key={id} value={id}>
                        {roomTypes[id]}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                  <TextField
                    label={t("Room id")}
                    name="roomId"
                    id="roomId"
                    required
                    fullWidth
                    select
                    onChange={(e) => {
                      formik.setFieldValue("roomId", e.target.value);
                      pricingRequestModel.newRate = null;
                      pricingRequestModel.newRateType = "TOTAL_PRETAX";
                      fetchUpdatedBookingPricing(e.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.roomId && Boolean(formik.errors.roomId)
                    }
                    helperText={formik.touched.roomId && formik.errors.roomId}
                    value={formik.values.roomId}
                  >
                    {roomIds.map((id) => (
                      <MenuItem
                        key={id?.roomId}
                        value={id?.roomId}
                        style={{
                          color: `${
                            id?.dirtyStatus === "CLEAN" ? "#1BC5BD" : "#B96E6E"
                          }`,
                          fontWeight: "bold",
                        }}
                      >
                        <Stack
                          direction={"row"}
                          spacing={2}
                          // style={{ display: "flex", justifyContent: "space-between" }}
                        >
                          <Typography sx={{ color: "black" }}>
                            {id.roomId}
                          </Typography>

                          <Typography
                            sx={{
                              color: `${
                                id?.dirtyStatus === "CLEAN"
                                  ? "#1BC5BD"
                                  : "#B96E6E"
                              }`,
                            }}
                          >
                            {id.dirtyStatus}
                          </Typography>
                        </Stack>
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {ratePlanchecked && (
                  <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                    <TextField
                      label={t("Rate plan")}
                      name="ratePlan"
                      id="ratePlan"
                      required
                      fullWidth
                      select
                      onChange={(e) => {
                        setselectedRatePlan(e.target.value);
                        fetchUpdatedBookingPricing("new", e.target.value);
                      }}
                      onBlur={formik.handleBlur}
                      value={selectedRatePlan}
                    >
                      {allRatePlans.map((id) => (
                        <MenuItem key={id[0]} value={id[0]}>
                          {id[1]}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                  <div className="d-flex">
                    <TextField
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      required
                      name="perNightPrice"
                      id="perNightPrice"
                      error={
                        formik.touched.perNightPrice &&
                        Boolean(formik.errors.perNightPrice)
                      }
                      helperText={
                        formik.touched.perNightPrice &&
                        formik.errors.perNightPrice
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {currency}
                          </InputAdornment>
                        ),
                      }}
                      placeholder={t("Per night excluding taxes")}
                      type="number"
                      value={formik.values.perNightPrice}
                      onBlur={formik.handleBlur}
                      disabled={
                        JSON.parse(
                          hotel?.accessControl?.user_feature_map
                            ?.EditBookingPrice
                        ).read !== "YES"
                          ? true
                          : load
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        formik.setFieldValue("perNightPrice", e.target.value);
                        setshowButtonOfPricing("perNightPrice");

                        if (e.target.value !== "" && e.target.value !== null) {
                          pricingRequestModel.newRate = e.target.value;
                          pricingRequestModel.newRateType = "PER_NIGHT_PRETAX";
                        }
                      }}
                      label={t("Upgrade cost excluding taxes")}
                    />
                    {showButtonOfPricing === "perNightPrice" && (
                      <Button
                        size="small"
                        style={{ marginLeft: "2rem" }}
                        variant="custom-button"
                        onClick={() => {
                          fetchUpdatedBookingPricing("perNightPrice");
                        }}
                        disabled={load}
                      >
                        {load ? (
                          <CircularProgress
                            size={15}
                            color="inherit"
                            sx={{ ml: 1.5 }}
                          />
                        ) : (
                          `${t("Apply")}`
                        )}
                      </Button>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                  <div className="d-flex">
                    <TextField
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      required
                      name="priceBeforeTax"
                      id="priceBeforeTax"
                      error={
                        formik.touched.priceBeforeTax &&
                        Boolean(formik.errors.priceBeforeTax)
                      }
                      helperText={
                        formik.touched.priceBeforeTax &&
                        formik.errors.priceBeforeTax
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {currency}
                          </InputAdornment>
                        ),
                      }}
                      placeholder={t("Total excluding tax")}
                      type="number"
                      value={formik.values.priceBeforeTax}
                      onBlur={formik.handleBlur}
                      disabled={
                        JSON.parse(
                          hotel?.accessControl?.user_feature_map
                            ?.EditBookingPrice
                        ).read !== "YES"
                          ? true
                          : load
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        formik.setFieldValue("priceBeforeTax", e.target.value);
                        setshowButtonOfPricing("priceBeforeTax");
                        if (e.target.value !== "" && e.target.value !== null) {
                          pricingRequestModel.newRate = e.target.value;
                          pricingRequestModel.newRateType = "TOTAL_PRETAX";
                        }
                      }}
                      label={t("Total excluding tax")}
                    />
                    {showButtonOfPricing === "priceBeforeTax" && (
                      <Button
                        size="small"
                        style={{ marginLeft: "2rem" }}
                        variant="custom-button"
                        onClick={() => {
                          fetchUpdatedBookingPricing("priceBeforeTax");
                        }}
                        disabled={load}
                      >
                        {load ? (
                          <CircularProgress
                            size={15}
                            color="inherit"
                            sx={{ ml: 1.5 }}
                          />
                        ) : (
                          `${t("Apply")}`
                        )}
                      </Button>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                  <div className="d-flex">
                    <TextField
                      fullWidth
                      required
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {currency}
                          </InputAdornment>
                        ),
                      }}
                      InputLabelProps={{ shrink: true }}
                      name="taxValue"
                      id="taxValue"
                      placeholder={t("Total tax")}
                      disabled
                      type="number"
                      value={formik.values.taxValue}
                      label={t("Total tax")}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                  <div className="d-flex">
                    <TextField
                      fullWidth
                      required
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {currency}
                          </InputAdornment>
                        ),
                      }}
                      InputLabelProps={{ shrink: true }}
                      name="priceAfterTax"
                      id="priceAfterTax"
                      placeholder={t("Total with tax")}
                      disabled={
                        JSON.parse(
                          hotel?.accessControl?.user_feature_map
                            ?.EditBookingPrice
                        ).read !== "YES"
                          ? true
                          : load
                          ? true
                          : false
                      }
                      type="number"
                      error={Boolean(formik.errors.priceAfterTax)}
                      helperText={formik.errors.priceAfterTax}
                      value={formik.values.priceAfterTax}
                      onChange={(e) => {
                        formik.setFieldValue("priceAfterTax", e.target.value);
                        setshowButtonOfPricing("priceAfterTax");
                        if (e.target.value !== "" && e.target.value !== null) {
                          pricingRequestModel.newRate = e.target.value;
                          pricingRequestModel.newRateType = "TOTAL_WITHTAX";
                        }
                      }}
                      onBlur={formik.handleBlur}
                      label={t("Total with tax")}
                    />
                    {showButtonOfPricing === "priceAfterTax" && (
                      <Button
                        style={{ marginLeft: "2rem" }}
                        size="small"
                        variant="custom-button"
                        onClick={() => {
                          fetchUpdatedBookingPricing();
                        }}
                        disabled={load}
                      >
                        {load ? (
                          <CircularProgress
                            size={15}
                            color="inherit"
                            sx={{ ml: 1.5 }}
                          />
                        ) : (
                          `${t("Apply")}`
                        )}
                      </Button>
                    )}
                  </div>
                </Grid>
              </Grid>
              <Divider />
              <div>
                <Fab
                  className={classes.footer}
                  type="submit"
                  disabled={
                    load ||
                    loadingData ||
                    !formik?.values?.roomId ||
                    showButtonOfPricing !== ""
                  }
                  variant="extended"
                  color="primary"
                >
                  {t("Assign")}

                  {load && (
                    <CircularProgress
                      size={15}
                      color="inherit"
                      sx={{ ml: 1.5 }}
                    />
                  )}
                </Fab>
              </div>
            </form>
          )}
          {showError && (
            <Grid
              sx={{ width: "100%", height: "max-content" }}
              container
              alignItems="center"
              direction="column"
              justifyContent="center"
            >
              <ErrorOutline sx={{ width: "50%", height: "50%" }} color="error">
                {/* <Grid item >
                <Typography> These was some error please try again !</Typography>
              </Grid> */}
              </ErrorOutline>
              <Grid item>
                <Typography>
                  {" "}
                  {t("These was some error please try again !")}
                </Typography>
              </Grid>
            </Grid>
          )}
        </Grid>
      </CommonSlider>
    </div>
  );
};

export default ReassignRoomFolio;
